import React from 'react';
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: ${props => props.flexD};
  align-items: ${props => props.alignItems};
  width: 100%;
  border: 1px solid ${props => props.theme.color.default_border_color};
  justify-content: space-between;
  padding: 12px 13px;
  margin-bottom: 10px;
  border-radius: 6px;
  background-color: ${props => props.theme.color.site_main_color};
`;

const TitleText = styled.span`
  color: ${props => props.theme.color.dark_100};
  font-size: 16px;
  font-weight: 500;
`;

const ChampionsHeader = ({title, children,flexD = 'row',alignItems='center'}) => {
    return (
        <Wrapper flexD={flexD} alignItems={alignItems}>
            {title && <TitleText>{title}</TitleText>}
            {children}
        </Wrapper>
    );
};



export default React.memo(ChampionsHeader);
